<template>
    <div>
        <div class="">
            <div class="faq-wrap">
                <div class="card-box"
                    style="padding-left: 20px;padding-right: 20px;padding-bottom: 10px;padding-top: 20px;">
                    <div class="card-header">
                        <div class="clearfix">
                            <div class="pull-left" style="display: inline-flex;text-decoration: underline;">
                                <h4 class="text-black h4" style="padding-right: 5px;">Tela: {{ NomeTela }} </h4>
                            </div>
                        </div>
                    </div>
                    <v-tabs v-model="tab" color="deep-purple-accent-4" bg-color="#f7f7f7" >
                        <v-tab value="dados" class="tabinfo">Dados</v-tab>
                     </v-tabs>
                     <v-window v-model="tab">
                        <v-window-item value="dados">
                            <v-form>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12" md="4" v-show="false">
                                            <v-text-field v-model="Entregas.ehrId" label="Id" variant="underlined"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="4" v-show="false">
                                            <v-text-field v-model="Entregas.grtId" label="Grupo" variant="underlined"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="4" v-show="false">
                                            <v-text-field v-model="Entregas.cdtId" label="Tela" variant="underlined"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="4" v-show="vshowidioma">
                                            <v-select v-model="Entregas.idiId" label="Idioma" :items="Idiomas" @update:modelValue="CarregaLista(Entregas.idiId)"
                                                item-title="idiNome" item-value="idiId" variant="underlined">
                                            </v-select>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" md="2">
                                            <v-select v-model="Entregas.ehrDia" label="Dia" :items="StatusDia"
                                                item-title="nome" item-value="ehrDia" variant="underlined">
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <v-select v-model="Entregas.ehrStatus" label="Ativo" :items="StatusAtivo"
                                                item-title="nome" item-value="ehrStatus" variant="underlined">
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <v-select v-model="Entregas.ehrHoraIni" label="Hora Inicial" :items="StatusHora"
                                                item-title="nome" item-value="valor" variant="underlined">
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <v-select v-model="Entregas.ehrMinIni" label="Min Inicial" :items="StatusMin"
                                                item-title="nome" item-value="valor" variant="underlined">
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <v-select v-model="Entregas.ehrHoraFim" label="Hora Final" :items="StatusHora"
                                                item-title="nome" item-value="valor" variant="underlined">
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <v-select v-model="Entregas.ehrMinFim" label="Min Final" :items="StatusMin"
                                                item-title="nome" item-value="valor" variant="underlined">
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <v-text-field v-model="Entregas.ehrQtde" type="number"
                                                label="Quantidade" variant="underlined" required></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-form>
                        </v-window-item>
                    </v-window>
                
                    <form v-if="tab=='dados'">
                        <div class="row">
                            <div class="col-md-12 text-center">
                                <button type="button" @click="Limpar()" class="btn btn-link">
                                    Cancelar
                                </button>
                                <button v-if="Entregas.ehrId != 0" type="button" class="btn btn-success" @click="Put()">
                                    Alterar
                                </button>
                                <button v-else type="button" class="btn btn-success" @click="Add()">
                                    Salvar
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="" v-if="MostraGrid && tab=='dados'">
            <div class="faq-wrap">
                <div class="card-box" style="padding-left: 20px;padding-right: 20px;padding-bottom: 10px;margin-top: 20px;">
                    <v-container>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field v-model="searchValue" label="Pesquisa" variant="underlined"
                                    required></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                    <easy-data-table :headers="headers" :items="ListEntregas" v-model="itemsSelected" alternating
                        theme-color="#364f66" table-class-name="customize-table" header-text-direction="center"
                        body-text-direction="center" rows-per-page-message="Linhas por pagina" :search-value="searchValue">
                        <template #item-ehrStatus="item">
                            <span>{{ item.ehrStatus ? 'Sim' : 'Não' }}</span>
                        </template>
                        <template #item-ehrDia="item">
                            <span>{{ item.ehrDia == 1 ? 'Semana' : item.ehrDia == 2 ? 'Sábado': 'Domingo' }}</span>
                        </template>
                        <template #item-ehrMinIni="item">
                            <span>{{ item.ehrMinIni == 0 ? '00' : item.ehrMinIni }}</span>
                        </template>
                        <template #item-ehrMinFim="item">
                            <span>{{ item.ehrMinFim == 0 ? '00' : item.ehrMinFim }}</span>
                        </template>
                        <template #item-actions="item">
                            <v-btn icon @click="EditGrid(item)" style="margin-right: 10px;" variant="text">
                                <v-icon>mdi-file-edit-outline</v-icon>
                                <v-tooltip activator="parent" location="top">Editar</v-tooltip>
                            </v-btn>

                            <v-btn icon @click="DeleteGrid(item)" variant="text">
                                <v-icon>mdi-delete-forever-outline</v-icon>
                                <v-tooltip activator="parent" location="top">Excluir</v-tooltip>
                            </v-btn>
                        </template>
                    </easy-data-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import moment from 'moment'

export default {
    name: 'EntregasHorariosView',
    components: {
        EasyDataTable,
        moment
    },
    data: () => ({
        editor: DecoupledEditor,
        tab: null,
        searchValue: '',
        itemsSelected: [],
        NomeTela:'Entregas Horários',
        InfoTela:'',
        MostraGrid: true,
        headers: [],
        Idiomas:[],
        vshowidioma: true,
        CadastroTelas:[{ cdtId: 23, cdtNome: "Entregas Horários" }],
        //dados
        Entregas: {
            ehrId: 0,
            grtId: 0,
            cdtId: 0,
            idiId: '',
            ehrStatus: '',
            ehrQtde: '',
            ehrHoraIni: '',
            ehrHoraFim: '',
            ehrMinIni: '',
            ehrMinFim: '',
            ehrDia: '',
        },
        ListEntregas: [],
        StatusAtivo: [{ nome: "Sim", ehrStatus: true }, { nome: "Não", ehrStatus: false }],
        StatusDia: [{ nome: "Semana", ehrDia: 1 }, { nome: "Sábado", ehrDia: 2 }, { nome: "Domingo", ehrDia: 3 }],
        StatusHora: [
            { nome: "0", valor: 0 },
            { nome: "1", valor: 1 },
            { nome: "2", valor: 2 },
            { nome: "3", valor: 3 },
            { nome: "4", valor: 4 },
            { nome: "5", valor: 5 },
            { nome: "6", valor: 6 },
            { nome: "7", valor: 7 },
            { nome: "8", valor: 8 },
            { nome: "9", valor: 9 },
            { nome: "10", valor: 10 },
            { nome: "11", valor: 11 },
            { nome: "12", valor: 12 },
            { nome: "13", valor: 13 },
            { nome: "14", valor: 14 },
            { nome: "15", valor: 15 },
            { nome: "16", valor: 16 },
            { nome: "17", valor: 17 },
            { nome: "18", valor: 18 },
            { nome: "19", valor: 19 },
            { nome: "20", valor: 20 },
            { nome: "21", valor: 21 },
            { nome: "22", valor: 22 },
            { nome: "23", valor: 23 },
        ],
        StatusMin: [
            { nome: "00", valor: 0 },
            { nome: "15", valor: 15 },
            { nome: "30", valor: 30 },
            { nome: "45", valor: 45 },
        ],
        //dados
        ListEntregasGeral:[],
    }),
    methods: {
        onReady(editor)  {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        formattedDate(value) {
            if (value!=null || value != ""){
                return this.$moment(value).format('DD/MM/YYYY')
            }
            else{
                return "";
            }
           
        },
        formatarValor(valor) {
            return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
        CarregaLista(){
           this.ListEntregas = this.ListEntregasGeral.filter(x=> x.idiId == this.Entregas.idiId);
        },
        Limpar() {
            this.Entregas.ehrId=0;
            this.Entregas.grtId=0;
            this.Entregas.cdtId=0;
            this.Entregas.ehrStatus="";
            this.Entregas.ehrQtde="";
            this.Entregas.ehrHoraIni="";
            this.Entregas.ehrHoraFim="";
            this.Entregas.ehrMinIni="";
            this.Entregas.ehrMinFim="";
            this.Entregas.ehrDia="";
            this.tab = 'dados';
            this.Get();
        },
        Add() {
               if (this.Entregas.idiId == '') {
                    this.$mensagemAviso("Campo Idioma Obrigatório.")
                }
                else if (this.Entregas.ehrQtde === '') {
                    this.$mensagemAviso("Campo Quantidade Obrigatório.")
                }
                else if (this.Entregas.ehrHoraIni === '') {
                    this.$mensagemAviso("Campo Hora Inicial Obrigatório.")
                }
                else if (this.Entregas.ehrMinIni === '') {
                    this.$mensagemAviso("Campo Minuto Inicial Obrigatório.")
                }
                else if (this.Entregas.ehrHoraFim === '') {
                    this.$mensagemAviso("Campo Hora Final Obrigatório.")
                }
                else if (this.Entregas.ehrMinFim === '') {
                    this.$mensagemAviso("Campo Minuto Final Obrigatório.")
                }
                else if (this.Entregas.ehrStatus === '') {
                    this.$mensagemAviso("Campo Status Obrigatório.")
                }
                else if (this.Entregas.ehrDia === '') {
                    this.$mensagemAviso("Campo Dia Obrigatório.")
                }
                else {
                    if (this.Entregas.ehrStatus === "" || this.Entregas.ehrStatus === null) {
                        this.Entregas.ehrStatus = true;
                    }

                    if (this.Entregas.ehrQtde === "" || this.Entregas.ehrQtde === null) {
                        this.Entregas.ehrQtde = 0;
                    }
                    else{
                        this.Entregas.ehrQtde = parseInt(this.Entregas.ehrQtde);
                    }
                                                 
                    axios.post(`/Process/EntEntregaHorarios/Add`, this.Entregas)
                        .then(response => {
                            if (response.data > 0) {
                                    this.Entregas.ehrId = response.data;
                                    this.$mensagemAvisoSucesso("Registro Incluído.")
                                    this.Get();
                                    this.Limpar();
                                    this.tab = 'dados';                        
                            }
                        });
            }
        },
        Put() {
            if (this.Entregas.idiId == '') {
                    this.$mensagemAviso("Campo Idioma Obrigatório.")
                }
                else if (this.Entregas.ehrQtde === '') {
                    this.$mensagemAviso("Campo Quantidade Obrigatório.")
                }
                else if (this.Entregas.ehrHoraIni === '') {
                    this.$mensagemAviso("Campo Hora Inicial Obrigatório.")
                }
                else if (this.Entregas.ehrMinIni === '') {
                    this.$mensagemAviso("Campo Minuto Inicial Obrigatório.")
                }
                else if (this.Entregas.ehrHoraFim === '') {
                    this.$mensagemAviso("Campo Hora Final Obrigatório.")
                }
                else if (this.Entregas.ehrMinFim === '') {
                    this.$mensagemAviso("Campo Minuto Final Obrigatório.")
                }
                else if (this.Entregas.ehrStatus === '') {
                    this.$mensagemAviso("Campo Status Obrigatório.")
                }
                else if (this.Entregas.ehrDia === '') {
                    this.$mensagemAviso("Campo Dia Obrigatório.")
                }
                else {
                    if (this.Entregas.ehrStatus === "" || this.Entregas.ehrStatus === null) {
                        this.Entregas.ehrStatus = true;
                    }
             
                axios.put(`/Process/EntEntregaHorarios/Update`, this.Entregas)
                    .then(response => {
                        if (response.status == 200) {
                            this.$mensagemAvisoSucesso("Registro Alterado.")
                            this.Get();
                            this.Limpar();
                            this.tab = 'dados';
                        }
                    });
            }
        },
        DeleteGrid(item) {

            this.$mensagemConfirma('Tem certeza que deseja excluir?')
            .then((result) => {
            if (result.isConfirmed) {
                // Lógica para excluir o item
                const param1 = item.ehrId;
                axios.delete(`/Process/EntEntregaHorarios/Delete/${param1}`)
                .then(response => {
                    if (response.status == 200) {
                        this.$mensagemAvisoSucesso("Registro Excluido.")
                        this.Get();
                        this.Limpar();
                        this.tab = 'dados';
                    }
                });
            }
            });
        },
        EditGrid(item) {
            this.tab = 'dados';
            this.Entregas = item;
            this.$scrollToTop();
        },
        montaGrid(){
            this.headers=[];
            this.headers.push({ text: "Id", value: "ehrId" });
            this.headers.push({ text: "Status", value: "ehrStatus" });
            this.headers.push({ text: "Dia", value: "ehrDia" });
            this.headers.push({ text: "Hora Inicial", value: "ehrHoraIni" });
            this.headers.push({ text: "Min Inicial", value: "ehrMinIni" });
            this.headers.push({ text: "Hora Fim", value: "ehrHoraFim" });
            this.headers.push({ text: "Min Fim", value: "ehrMinFim" }); 
            this.headers.push({ text: "Quantidade", value: "ehrQtde" }); 
            this.headers.push({ text: 'Ações', value: 'actions' });
        },
        Get() {
            axios.get(`/Process/CadIdiomas/GetAll`)
                .then(response => {
                    this.Idiomas = response.data.filter(x => x.idiAtivo);
                    if (this.Idiomas.length == 1) {
                        this.Entregas.idiId = this.Idiomas[0].idiId;
                        this.vshowidioma = false;
                    }
                    axios.get(`/Process/EntEntregaHorarios/GetAll`)
                        .then(response => {
                            this.ListEntregasGeral = response.data; 
                            if (this.Entregas.idiId != ''){
                                this.CarregaLista();
                            }                           
                        });
                    this.montaGrid();
                    this.Entregas.cdtId = 23;
                    this.Entregas.grtId = 5;

                });
        }
    },
    created() {
        this.Get();
    },
}
</script>

<style scoped>
  .tabinfo{
    font-size:14px;
    text-transform: capitalize;
  }
</style>
